import type { FC } from "react";

import { SentimentOverview } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sentiment-report/sentiment-overview/SentimentOverview";
import { TopicsGraph } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sentiment-report/topics-graph/TopicsGraph";
import type { ILLMReport } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

import { BrandComparisonComponent } from "./brand-comparison/BrandComparisonComponent";

export const SentimentReport: FC<ILLMReport> = (reportProps) => {
    return (
        <>
            <SentimentOverview {...reportProps} />
            <TopicsGraph {...reportProps} />
            <BrandComparisonComponent {...reportProps} />
        </>
    );
};
